module.exports = __webpack_public_path__ + "img/hyjmd2-img6.fe416f0e.png";